import { IOperatorRegionExpensePrice, IOperatorRegionPrice } from "src/Interfaces/AdminInterface";
import { download } from "src/UtilityFunctions/ExportData";


export default class CsvService {
    public static exportOperatorPriceList(operatorName: string, regionName: string, operatorPriceList: IOperatorRegionPrice[], operatorExpenseList: IOperatorRegionExpensePrice[]) {
        const rawContent = [
            `Product Name,Primary Category,Taxable,Size,Unit,Specific Gravity,Weight,Cost,Price`
        ];
        operatorPriceList.forEach((op, index) => {
            const oneRow = 
            `"${op.name}","${op.category}","${op.isTaxable ? 'Yes' : 'No' }","${op.size}","${op.unit}","${op.specificGravity}","${op.weight}","${op.cost}","${op.price}"`;
            rawContent.push(oneRow);
        });
        rawContent.push("");
        rawContent.push('Name,Type,Taxable,Cost,Price');
        operatorExpenseList.forEach(oe => {
            const oneRow =
            `"${oe.name}","${oe.isRental ? 'Rental' : 'Service'}","${oe.isTaxable ? 'Yes' : 'No'}","${oe.cost}","${oe.price}"`;
            rawContent.push(oneRow);
        });
        const csvContent = rawContent.join('\n');
        download(csvContent, `${operatorName}-${regionName}-${new Date().toISOString().slice(0,10)}-Prices.csv`, 'data:text/csv;charset=utf-8,');
    }
    // Added EBP and Product to same list
    // public static exportOperatorEbpList(operatorName: string, regionName: string, operatorExpenseList: IOperatorRegionExpensePrice[]) {
    //     const rawContent = [
    //         'Name,Type,Taxable,Cost,Price',
    //     ];
    //     operatorExpenseList.forEach(oe => {
    //         const oneRow =
    //         `"${oe.name}","${oe.isRental ? 'Rental' : 'Service'}","${oe.isTaxable ? 'Yes' : 'No'}","${oe.cost}","${oe.price}"`;
    //         rawContent.push(oneRow);
    //     });
    //     const csvContent = rawContent.join('\n');
    //     download(csvContent, `${operatorName}-${regionName}-${new Date().toISOString().slice(0,10)}-EBP.csv`, 'data:text/csv;charset=utf-8,');
    // }
}


// WEBPACK FOOTER //
// ./src/Services/Csv/CsvService.ts